import {
  DEMOGRAPHIC_FORM_INPUT_CHANGE,
  PAYOR_FORM_INPUT_CHANGE,
  RESET_PAYOR_FORM,
  SET_INITIAL_COUNTRY,
} from '../types';

const initialState = {
  demographicInfo: {
    thirdPartyRepair: null,
    concernNote: '',
    reimbursementAmount: '',
    mailingAddress: '',
    city: '',
    state: '',
    zip: '',
    countryCode: 'US',
    firstName: '',
    lastName: '',
    phone: '',
  },
  payorInfo: {
    payorName: '',
    iban: '',
    bicSwiftBsb: '',
    bankName: '',
    accountNumber: '',
    accountName: '',
    bankCode: '',
    branchCode: '',
    bankValidation: '',
    branchName: '',
    accountType: '',
    accountHolderName: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_INITIAL_COUNTRY:
      return {
        ...state,
        demographicInfo: {
          ...state.demographicInfo,
          countryCode: action.payload.localeCountry,
        },
      };
    case DEMOGRAPHIC_FORM_INPUT_CHANGE:
      return {
        ...state,
        demographicInfo: {
          ...state.demographicInfo,
          ...action.payload,
        },
      };
    case PAYOR_FORM_INPUT_CHANGE:
      return {
        ...state,
        payorInfo: {
          ...state.payorInfo,
          ...action.payload,
        },
      };
    case RESET_PAYOR_FORM:
      return {
        ...state,
        payorInfo: {
          ...initialState.payorInfo,
        },
      };
    default:
      return state;
  }
};
